import { Provider } from 'react-redux';
import { agentStore } from './index';

export function AgentStoreProvider({ children }: { children: React.ReactNode }) {
  return <Provider store={agentStore}>{children}</Provider>;
}
